import { IAppState } from '../../redux';
import { TPaymentProvider } from '../../types/reducers/paymentProviders';

export const selectMainPaymentProvider = (state: IAppState): TPaymentProvider => {
  return state.paymentProviders.mainProvider;
};
